import { useQuery } from 'react-query';

import { getPoapPrimaryViews as queryFn } from 'api/endPoints/getPoapPrimaryViews';
import { QueryKeys } from 'api/queryKeys';

export const GET_POAP_PRIMARY_VIEWS_QUERY_KEY: QueryKeys = 'getPoapPrimaryViews' as const;

export const useQueryGetPoapPrimaryViews = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: [GET_POAP_PRIMARY_VIEWS_QUERY_KEY, params],
        queryFn: () => queryFn({ customerId: params.customerId }),
        enabled: Boolean(params.customerId) && Boolean(params.username),
        select: (response) => {
            return response.map((view) => {
                return {
                    ...view,
                    isOwner: view.viewOwner === params.username,
                };
            });
        },
    });
};

export interface QueryParams {
    customerId: number | undefined;
    username: string | undefined;
}

export const COLOR_BY_KEYS = {
    SPI: 'SPI',
    STATUS: 'STATUS',
} as const;

export type ColorByType = (typeof COLOR_BY_KEYS)[keyof typeof COLOR_BY_KEYS];

interface PoapView {
    hidden: boolean;
    public: boolean;
    viewId: number;
    viewName: string;
    viewOrder: number;
    viewOwner: string;
    showBaseline: boolean;
    showlabels: boolean;
    colorBy: ColorByType;
    viewRows: {
        compareVersionId: number;
        contractId: number;
        filterItem: string;
        filterItemReferences: string[];
        id: number;
        latestVersionId: number;
        name: string;
        progressMeasurementMethod: string;
        projectId: number;
        rowOrder: number;
        rowType: string;
    }[];
}

export interface PoapViewResponse extends PoapView {
    isOwner: boolean;
}

type QueryFnResponse = PoapView[];

type QueryResponse = PoapViewResponse[];
